import React from 'react';
import { BsCursor } from '@react-icons/all-files/bs/BsCursor';
import { BsCursorFill } from '@react-icons/all-files/bs/BsCursorFill';

import { decorateComponent } from '../../../documentComponents';
import { AccordionButton } from './AccordionButton';
import { AccordionButtonInspector } from './AccordionButton.Inspector';

export default decorateComponent(AccordionButton, 'block', {
  id: 'accordionButton',
  allowedParent: ['accordion'],
  allowedChildren: ['text', 'image', 'block'],
  disabledDelete: true,
  disabledClone: true,
  disabledMove: true,
  renderIcon: ({ action }) => (action === 'expand' ? <BsCursorFill /> : <BsCursor />),
  renderTitle: ({ action }) => `아코디언 ${action === 'expand' ? '펼치기' : '접기'} 버튼`,
  renderInspector: AccordionButtonInspector,
});
